(function () {
    'use strict';

    angular
        .module('governanceProcessModule')
        .controller('grcGovernanceProcessFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'govNotificationDelay', 'notificationService', 'recomService'];

    function Controller($rootScope, $scope, $state, $timeout, govNotificationDelay, notificationService, recomService) {
        $scope.ctxtCtrl = {};

        $scope.boxModel = $scope.boxModel || {};
        $scope.boxModel.ODDBusinessUnitID = $scope.boxContext.businessUnit.ODDBusinessUnitID;

        if (!$scope.boxModel.GovernanceProcessID) {
            $scope.boxModel.IsActive = true;
        }

        $scope.createOrUpdate = function () {
            if ($scope.ctxtCtrl.isSubmitting) return;

            if ($scope.form.$invalid) {
                showFormError();
                return;
            }

            if (!$scope.isPageDirty()) return;

            $scope.ctxtCtrl.isSubmitting         = true;
            $scope.ctxtCtrl.isFormInvalidMsgShow = false;

            if (!$scope.boxModel.GovernanceProcessID) {
                return createGovernanceProcess();
            }

            return updateGovernanceProcess();
        };

        // Cancel
        $scope.cancel = function () {
            $scope.form.$setPristine();
            $scope.setPageNotDirty();
            $state.go('recom.listGovernanceProcess');
        };

        // Reset forms
        $scope.reset = function () {
            $state.reload();
        };

        // Prevent navigation with unsaved changes
        var removeListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            if ($scope.isPageDirty() && toState.url !== fromState.url) {
                event.preventDefault();
                $scope.confirmClick();
            }
        });
        $scope.$on("$destroy", removeListener);

        function createGovernanceProcess() {
            recomService
                .createGovernanceProcess($scope.boxModel)
                .then(function (createdGovProcess) {
                    notificationService.notify('The Governance Process was created');
                    $scope.form.$setPristine();
                    $scope.setPageNotDirty();

                    $state.go('recom.editGovernanceProcess', {BusinessUnitCode: createdGovProcess.RecomBusinessUnit.Code, GovernanceProcessID: createdGovProcess.GovernanceProcessID});
                })
                .finally(function () {
                    $scope.ctxtCtrl.isSubmitting = false;
                });
        }

        function updateGovernanceProcess() {
            recomService
                .updateGovernanceProcess($scope.boxModel)
                .then(function (updatedGovernanceProcess) {
                    notificationService.notify('The Governance Process was updated');
                    $scope.form.$setPristine();

                    $scope.boxModel = updatedGovernanceProcess;
                    $scope.setPageNotDirty();
                    if (!$scope.boxModel.IsActive) {
                        $state.go('recom.listGovernanceProcess', {replace: true});
                    }
                })
                .finally(function () {
                    $scope.ctxtCtrl.isSubmitting = false;
                });
        }

        function showFormError() {
            $scope.ctxtCtrl.showSubmitError = true;
            $scope.ctxtCtrl.isFormInvalidMsgShow = true;
            $timeout(function () {
                $scope.ctxtCtrl.isFormInvalidMsgShow = false;
            }, govNotificationDelay);
        }
    }
})();
